var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.7 19.7",
    style: {
      enableBackground: "new 0 0 19.7 19.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#698DB0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,7.6c-1-4.5-5-7.6-9.6-7.6C8,0,6.1,0.5,4.6,1.5c-1.2,0.8-2.3,1.8-3,3C0.5,6.1,0,8,0,9.9 c0,0.7,0.1,1.3,0.2,2c0.9,4.6,5,7.9,9.6,7.9c1.9,0,3.7-0.5,5.3-1.5c1.2-0.8,2.2-1.8,3-3h0c1-1.6,1.5-3.4,1.5-5.3 C19.7,9.1,19.6,8.4,19.4,7.6z M9.9,18.4c-4.7,0-8.6-3.9-8.6-8.6c0-4.7,3.9-8.6,8.6-8.6s8.6,3.9,8.6,8.6 C18.4,14.6,14.6,18.4,9.9,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,5C9.4,5,9,5.4,9,5.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9C10.7,5.4,10.3,5,9.8,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,8C9.4,8,9,8.4,9,8.8v5.1c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8V8.8C10.6,8.4,10.3,8,9.8,8z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about.ab387139.svg";
export { ForwardRef as ReactComponent };